import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ShowHideTable } from "../../components/ShowHideTable";
import SubHeaderBox from "../../components/SubHeaderBox";
import InventoryChemicalTable from "./Table";
import { getSystemBoundarySubcategory } from "../../../../../apis/Business/InventoryApi";
import inventoryChemicalIcon from "../../../../../assets/design-revamp-company/category-icons/inventory_chemical_icon.svg";
const InventoryChemical = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState();
  const [systemBoundaryChemical, setSystemBoundaryChemical] = useState();

  useEffect(() => {
    getSystemBoundarySubcategory({
      businessId: businessId,
      setSystemBoundarySubCategory: setSystemBoundaryChemical,
      subcategory: "chemicals",
    });
  }, [businessId]);
  return (
    <div className="component-energy-contents">
      <div style={{ marginTop: "12px" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <SubHeaderBox
            subTitle={t("CHEMICALS")}
            subDescription={t("DESC_INV_CHEMICALS")}
            isNormal={true}
            number={"5.1.6"}
            icon={inventoryChemicalIcon}
            systemBoundaryProps={{
              systemBoundary: systemBoundaryChemical,
              businessId: businessId,
              setSystemBoundary: setSystemBoundaryChemical,
              isInventory: true,
              customStyles: { marginTop: "10px" },
              totalObjCategory: "chemicals",
            }}
            showSystemBoundary={true}
          />
        </div>

        {showTable && <InventoryChemicalTable businessId={businessId} />}
        <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
      </div>
    </div>
  );
};

export default InventoryChemical;
